import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionInterface } from '../interfaces/permission.interface';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsGuard implements CanActivate {
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.hasPermission(route);
  }

  constructor(private storageService: StorageService) {}

  hasPermission(component): boolean {
    const permissionXD: string = component.data.permission;
    const permissions: PermissionInterface =
      this.storageService.get('permissions');

    const map = new Map(Object.entries(permissions));
    return map.get(permissionXD);
  }
}
